// src/Organisms/OrganismPaginatedTable/OrganismPaginatedTable.js
// Organism : Composant qui assemble la table, la pagination et le sélecteur d'éléments par page.

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MoleculePaginationSimple from '../../Molecules/MoleculePaginationSimple/MoleculePaginationSimple';
import AtomNumberDisplay from '../../Atoms/AtomNumberDisplay/AtomNumberDisplay';

const OrganismPaginatedTable = ({ data, columnTitles }) => {
  const [itemsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(data.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = data.slice(startIndex, endIndex);

  return (
    <div className="w-full">
      { /* MoleculeItemsPerPageSelector value={itemsPerPage} onChange={handleItemsPerPageChange} /> */ }
      <table className="table table-responsive table-hover w-full">
        <thead className="thead-muted">
        <tr>
          {columnTitles.map((title) => (
            <th key={title} scope="col" className="font-weight-normal small bg-light text-secondary">
              {title}
            </th>
          ))}
        </tr>
        </thead>
        <tbody>
        {currentData.map((item) => (
          <tr key={item.id}>
            <td>{item.codePolice}</td>
            <td>{item.dateReglement}</td>
            <td>
              <div className={`echeance echeance-${item.color}`}>
                {item.echeanceDebut}<br />au {item.echeanceFin}
              </div>
            </td>
            <td className="text-right">
              <AtomNumberDisplay value={item.montant} withCurrency={true} />
            </td>
            <td className="text-right">
              <AtomNumberDisplay value={item.montantDu} withCurrency={true} />
            </td>
            <td className="text-right">
              <AtomNumberDisplay value={item.montantRegle} withCurrency={true} />
            </td>
            <td>{item.remarque}</td>
            <td className="text-right">
              <AtomNumberDisplay value={item.montantFrais} withCurrency={true} />
            </td>
            <td>{item.statut}</td>
          </tr>
        ))}
        </tbody>
      </table>

      {data.length > itemsPerPage && (
        <MoleculePaginationSimple
          currentPage={currentPage}
          totalPages={totalPages}
          onPrevious={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          onNext={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
        />
      )}
    </div>
  );
};

// Validation des props
OrganismPaginatedTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      codePolice: PropTypes.string,
      dateReglement: PropTypes.string,
      color: PropTypes.string,
      echeanceDebut: PropTypes.string,
      echeanceFin: PropTypes.string,
      montant: PropTypes.number,
      montantDu: PropTypes.number,
      montantRegle: PropTypes.number,
      remarque: PropTypes.string,
      montantFrais: PropTypes.number,
      statut: PropTypes.string,
    })
  ).isRequired,
  columnTitles: PropTypes.arrayOf(PropTypes.string).isRequired, // Liste de titres de colonnes
};

export default OrganismPaginatedTable;
